// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnInit
} from '@angular/core';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMColumnsBaseComponent } from './lm-columns-base.component';
import { LMFormLayoutService } from '@form/services/lm-form-layout.service';
import { LMLayoutUtilDirective } from './lm-layout-util.directive';
import { LMLoggerService } from '@app/services';

@Component({
  selector: 'lm-columns-distributed',
  templateUrl: 'lm-columns-distributed.component.html',
  styleUrls: [ 'lm-columns-distributed.component.scss' ],
  providers: [ LMLayoutUtilDirective, LMFormLayoutService ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMColumnsDistributedComponent extends LMColumnsBaseComponent implements OnInit {

  @HostBinding('class.lm-single-column') isSingleColumn = false;

  constructor(
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormLayoutService: LMFormLayoutService,
    protected lmLoggerService: LMLoggerService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(lmConditionUtilService, lmFormLayoutService, lmLoggerService, changeDetectorRef);
  }

  ngOnInit() {
    super.ngOnInit();
    // Set columns for template
    if (this.lmFormLayoutService.columnsAreImplicit(this.layoutObject)) {
      this.columns = this.lmFormLayoutService.buildImplicitColumns(this.layoutObject, this.model);
    } else {
      this.layoutObject.columns.forEach((column, i) => {
        column.index = i;
      });
      this.columns = this.layoutObject.columns;
    }

    if (this.layoutObject.nbrColumns === 1) {
      this.isSingleColumn = true;
    }
  }
}
